import type { Vue } from './BasculeVue';

/**
 * Au téléphone, un seul geste (chantier `telephone-cadre`, ticket 04, décisions d'Igor du
 * 2026-10-05 : revue 2, 3 et 13, cadrage 4 et 5, maquette `design/telephone.html`, « Une étape
 * ouverte »).
 *
 * - **Rien dedans, c'est une tâche** : le rond la coche d'un toucher (`rondQuiCoche.ts`), le
 *   reste de la ligne ouvre sa fiche.
 * - **Quelque chose dedans, même fait, c'est une étape** : un › au bout, pas de rond ; la
 *   toucher y entre, un niveau à la fois, comme dans un dossier.
 * - **L'appui long ouvre la fiche**, étape comme tâche : le raccourci vers la fiche d'une étape
 *   sans y entrer (`appuiLong.ts`).
 *
 * Pas de type nouveau dans la base : seul le compte de ce que la bulle contient décide.
 * L'ordinateur ne passe jamais par ici : il garde le clic qui ouvre la fiche et le double-clic
 * qui entre (`deuxGestes.ts`), le chevron qui déplie sur place, la Carte et la Hiérarchie.
 */
export type SorteDeLigne = 'tache' | 'etape';

export function sorteDeLigne(bulle: { nbEnfants: number }): SorteDeLigne {
  return bulle.nbEnfants > 0 ? 'etape' : 'tache';
}

export interface GestesDeLaLigne {
  /** Le rond qui coche : seulement devant une tâche. */
  rond: boolean;
  /** Ce que fait un toucher bref sur la ligne. */
  toucher: 'fiche' | 'entrer';
  /** Ce que fait le doigt gardé posé. */
  appuiLong: 'fiche';
  /** Le › au bout de la ligne : on entre dedans. */
  entrer: boolean;
}

export function gestesDeLaLigneAuPouce(bulle: { nbEnfants: number }): GestesDeLaLigne {
  const etape = sorteDeLigne(bulle) === 'etape';
  return { rond: !etape, toucher: etape ? 'entrer' : 'fiche', appuiLong: 'fiche', entrer: etape };
}

/**
 * La vue que la feuille montre : au téléphone, toujours la liste (décision 3 de la revue, « La
 * Carte et la Hiérarchie restent sur l'ordinateur »), même quand on arrive en demandant la Carte
 * (une partie de l'Aide) ou qu'on avait choisi une autre vue à l'ordinateur.
 */
export function vueMontree(choisie: Vue, auPouce: boolean): Vue {
  return auPouce ? 'liste' : choisie;
}
